import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface UserState {
  id: string;
  name: string;
  role: string;
  email: string;
  auditor: string;
  organizationId: number;
  auditTypeId: number;
}

const initialState: UserState = {
  id: "",
  name: "",
  role: "",
  email: "",
  auditor: "",
  organizationId: 0,
  auditTypeId: 0,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserInfo: (state, action: PayloadAction<UserState>) => {
      state.id = action.payload.id;
      state.name = action.payload.name;
      state.role = action.payload.role;
      state.email = action.payload.email;
      state.auditor = action.payload.auditor;
      state.organizationId = action.payload.organizationId;
      state.auditTypeId = action.payload.auditTypeId;
    },
    clearUserInfo: (state) => {
      state.id = "";
      state.name = "";
      state.role = "";
      state.email = "";
      state.auditor = "";
      state.organizationId = 0;
      state.auditTypeId = 0;
    },
  },
});

export const { setUserInfo, clearUserInfo } = userSlice.actions;
export default userSlice.reducer;
